// extracted by mini-css-extract-plugin
export default {"container":"CartSummaryButton-container_Tr7Fa","scrollBottom":"CartSummaryButton-scrollBottom_loBW8","information":"CartSummaryButton-information_dcns3"};